import { render, staticRenderFns } from "./preview-custom-page.vue?vue&type=template&id=0ae556b2&scoped=true&"
import script from "./preview-custom-page.vue?vue&type=script&lang=js&"
export * from "./preview-custom-page.vue?vue&type=script&lang=js&"
import style0 from "./preview-custom-page.vue?vue&type=style&index=0&id=0ae556b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae556b2",
  null
  
)

export default component.exports